module.exports = __webpack_public_path__ + "img/48.aa9b5e05.png";